export default __webpack_public_path__ + "287f53b620832fd4fba9195abb2d5fd0.png";